import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAsset from "@components/WebsiteRevamp/ContentAsset/ContentAsset"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CompanyHistorySection.module.scss"
type Props = {
	data: AdvancedSideAssetModuleType
}

const CompanyHistorySection = (props: Props) => {
	const mainContent = props.data.mainContent

	return (
		<section style={{background: "#F8FAFE"}}>
			<ContainerWrapper>
				<Separator size={128}>
					<Typography
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					{mainContent && (
						<div className={styles.historyBox}>
							<Separator size={64} />
							{/* <Description content={mainContent[0].title} />
							<Separator size={8} /> */}
							<ContentAsset
								contentProps={{
									data: mainContent[0],
									subtitleProps: {
										content: mainContent[0].title,
										variant: Variant.Description,
									},
									without: {title: true},
								}}
								withAspectRation
								data={mainContent[0]}
							/>

							<Separator size={128} />
							{/* <Description
								content={mainContent[1].title}
								size={"L"}
							/> */}
							<ContentAsset
								contentProps={{
									data: mainContent[1],
									subtitleProps: {
										content: mainContent[1].title,
										variant: Variant.Description,
									},
									without: {title: true},
								}}
								withAspectRation
								data={mainContent[1]}
							/>
						</div>
					)}
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default CompanyHistorySection
